import React, { useEffect, useState } from "react";
import useApi from "../../api";
import { NXAlertCircle } from "../../icons";
import moment from "moment";
import { handleRetriveError } from "../../utils";

interface CardGroupProps {
  filterParams: any;
}

const ItemKeyPoints: React.FC<CardGroupProps> = ({ filterParams }) => {
  const api = useApi();
  const [data, setData] = useState<any>();

  const fetchOrderStateOverview = () => {
    api.getOrderStateOverview(filterParams).then(
      (response) => {
        setData(response);
      }, handleRetriveError);
  };

  useEffect(() => {
    if (filterParams.start_date && filterParams.end_date) {
      fetchOrderStateOverview();
    }
  }, [filterParams]);

  const dataItem = [
    {
      title: "Order Pending",
      value: data?.order_pending?.amount,
      element: <p className="text-[13px]">Last order: {moment(data?.order_pending?.last_order).format('MMMM Do YYYY, h:mm:ss a')}</p>,
    },
    {
      title: "Order Delivered",
      value: data?.order_delivered?.amount,
      element: (
        <p className="text-[13px]">
            <span className={`text-primary-500 ${data?.order_delivered?.last_percentage_change < 0 ? 'text-red-500' : ''}`}>
            {data?.order_delivered?.last_percentage_change > 0 ? '+' : ''}{data?.order_delivered?.last_percentage_change}% 
            </span>
          <span className="text-base-300">from {data?.percetage_change_preiod_title}</span>
        </p>
      ),
    },
    {
      title: "Order Returned",
      value: data?.order_returned?.amount,
      element: (
        <p className="text-[13px]">
            <span className={`text-primary-500 ${data?.order_returned?.last_percentage_change < 0 ? 'text-red-500' : ''}`}>
            {data?.order_returned?.last_percentage_change > 0 ? '+' : ''}{data?.order_returned?.last_percentage_change}% 
            </span>
          <span className="text-base-300">from {data?.percetage_change_preiod_title}</span>
        </p>
      ),
    },
    {
      title: "Order Cancelled",
      value: data?.order_cancelled?.amount,
      element: (
        <p className="text-[13px]">
            <span className={`text-red-500 ${data?.order_cancelled?.last_percentage_change < 0 ? 'text-primary-500' : ''}`}>
            {data?.order_cancelled?.last_percentage_change > 0 ? '+' : ''}{data?.order_cancelled?.last_percentage_change}% 
            </span>
          <span className="text-base-300">from {data?.percetage_change_preiod_title}</span>
        </p>
      ),
    },
  ];

  return (
    <>
      <div className="flex flex-row w-full gap-5 mt-5 bg-white rounded-lg p-5 mb-5">
        {dataItem.map((item, index) => (
          <div
            key={item.title}
            className={`flex-1 rounded-lg p-3 border border-[#EEEFF2] ${
              index === 0 && "bg-primary-500 text-white"
            }`}
          >
            <div className="flex justify-between font-lato font-[400] text-[13px]">
              <p
                className={`${index === 0 ? "text-white" : "text-base-300"}`}
              >
                {item.title}
              </p>
              <NXAlertCircle className="w-4" />
            </div>
            <h5 className="font-nunito font-nunito-h2 lg:text-md xl:text-xl">
              {item.value}
            </h5>
            {item.element}
          </div>
        ))}
      </div>
    </>
  );
};

export default ItemKeyPoints;
